import { render, staticRenderFns } from "./TvRemoteWidget.vue?vue&type=template&id=2db008a0"
import script from "./TvRemoteWidget.vue?vue&type=script&lang=js"
export * from "./TvRemoteWidget.vue?vue&type=script&lang=js"
import style0 from "./TvRemoteWidget.vue?vue&type=style&index=0&id=2db008a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports